// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import Dialog from 'presentations/views/components/atoms/Dialog';
import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';
import { ViewerItem } from 'presentations/api/schema/user';
import { useContactEditForm } from './hooks';
import EventTypeContactFormBlock from '../EventTypeContactFormBlock';
import { EventDetailItem } from 'presentations/api/schema/event';
import SendUpdatesDialog from '../SendUpdatesDialog';
import Workflow from 'domains/models/workflow';

interface Props {
  viewer: ViewerItem;
  isOpen: boolean;
  event: EventDetailItem | null;
  onCancel?: any;
  onUpdated?: any;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const { state, actions } = useContactEditForm({
    viewer: props.viewer,
    event: props.event,
    onUpdated: props.onUpdated,
  });

  const customOtherAnswers = [];
  const customQuestionAnswers: Array<string | string[]> = [];
  for (const answer of state.answers ?? []) {
    const workflow: Workflow = state.form?.workflows.find(
      (q: Workflow) => q.content === answer.question,
    );
    if (!workflow) {
      continue;
    }
    const choiceValues = workflow.choices?.map((c) => c.value);

    if (Array.isArray(answer.content)) {
      let otherAnswer = '';
      const answers: string[] = [];
      for (const content of answer.content) {
        if (choiceValues?.includes(content)) {
          // answer.contentが選択肢にある場合
          answers.push(content);
        } else {
          // answer.contentがその他の場合
          answers.push(t('other'));
          otherAnswer = content;
        }
      }

      customQuestionAnswers.push(answers);
      customOtherAnswers.push(otherAnswer);
    } else if (typeof answer.content === 'string' || answer.content === null) {
      if (workflow.hasOtherChoice) {
        if (answer.content && choiceValues?.includes(answer.content)) {
          // answer.contentが選択肢にある場合
          customQuestionAnswers.push(answer.content);
          customOtherAnswers.push('');
        } else {
          // answer.contentがその他の場合
          customQuestionAnswers.push(t('other'));
          customOtherAnswers.push(answer.content ?? '');
        }
      } else {
        customQuestionAnswers.push(answer.content ?? '');
        customOtherAnswers.push('');
      }
    }
  }

  const contactFormProps = {
    email: state.email,
    name: state.name,
    company: state.company,
    ccEmails: state.ccEmails,
    message: state.message,
    phoneNumber: state.phoneNumber,
    textRemindCountry: state.textRemindCountry,
    textRemindNumber: state.textRemindNumber,
    customQuestions: state.customQuestions,
    customQuestionAnswers,
    customOtherAnswers,
    locationId: props.event?.locationId ?? null,
    onChange: actions.onChange,
    onChangeTextRemindNumber: actions.onChangeTextRemindNumber,
    // onBlur: actions.onBlur,
    onInputChangeTag: actions.onInputChangeTag,
    onSubmitTag: actions.onSubmitTag,
    onDeleteTag: actions.onDeleteTag,
    // onSubmit: actions.onSubmitContact,
    onClickOtherAnswer: actions.onChangeOtherAnswer,
    isLoading: false,
    isDisabled: false,
    errors: {},
    // 作成後に設定が更新されている可能性があるため全項目を表示する
    isCompanyHidden: false,
    isPhoneNumberRequired: false,
    isTextRemindNumberRequired: false,
    isTextRemind: state.eventTypeSetting?.isTextRemind,
    isCompanyRequired: false,
    isCcEmailsHidden: false,
    isCcEmailsRequired: false,
    isMessageHidden: false,
    isMessageRequired: false,
    color: 'primary',
    isLightColor: true,
    selectedServices: [],
    isPaidServiceSelected: false,
    isProvidedContact: false,
    isRequest: false,
    isSelectedServicesHidePriceOnly: false,
  };

  return (
    <StyledDialog
      isOpen={props.isOpen}
      title={t('Title')}
      isFillWidth
      actions={
        <DialogSubmitField
          isLoading={state.isLoading}
          onSubmit={actions.onSubmitForm}
          onCancel={props.onCancel}
          // isDisabled={state.isInitLoading}
          submitLabel={t('Submit')}
        />
      }
    >
      <EventTypeContactFormBlock {...contactFormProps} />
      {state.isShowResendConfirm && (
        <SendUpdatesDialog
          isOpen={state.isShowResendConfirm}
          onCancel={actions.onCloseResendConfirmDialog}
          onSubmit={actions.onSubmit}
          isLoading={state.isLoading}
        />
      )}
    </StyledDialog>
  );
}

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 800px;
  }
`;
